import React, { Component } from 'react'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { Row, Col, Modal, Popconfirm, message } from 'antd'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { compose } from 'recompose'
import moment from 'moment'
import { RoleCode } from '../../../constants'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { AuthStore, visible, onCancel, reservation } = this.props
		const { user_type } = AuthStore
		const isAdmin = (_.isEqual(user_type, RoleCode.SYSTEMADMIN) || _.isEqual(user_type, RoleCode.SUPERADMIN))

		return (
			<Modal
				title='View Reservation Details'
				width='35%'
				visible={visible}
				onCancel={onCancel}
				destroyOnClose
				footer={null}
			>
				<Row type='flex' justify='center' gutter={24}>
					<Col md={18} sm={24}>
						<Row gutter={16}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>Facility</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{reservation.facility_name}</h4>
							</Col>
						</Row>
					</Col>
					<Col md={18} sm={24}>
						<Row gutter={16} style={{ marginTop: 10 }}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>Person who reserve</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{reservation.name}</h4>
							</Col>
						</Row>
					</Col>
					<Col md={18} sm={24}>
						<Row gutter={16} style={{ marginTop: 10 }}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>Start At</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{moment(reservation.from_date).format('lll')}</h4>
							</Col>
						</Row>
					</Col>
					<Col md={18} sm={24}>
						<Row gutter={16} style={{ marginTop: 10 }}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>End At</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{moment(reservation.to_date).format('lll')}</h4>
							</Col>
						</Row>
					</Col>
					<Col md={18} sm={24}>
						<Row gutter={16} style={{ marginTop: 10 }}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>Remarks</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{reservation.remarks}</h4>
							</Col>
						</Row>
					</Col>
					<Col md={18} sm={24}>
						<Row gutter={16} style={{ marginTop: 10 }}>
							<Col md={10} sm={24}>
								<h4 style={{ color: 'gray' }}>Created At</h4>
							</Col>
							<Col md={14} sm={24}>
								<h4>{moment(reservation.created_at).format('lll')}</h4>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row style={{ marginTop: 20 }} type='flex' justify='center'>
					{
						isAdmin &&
						<Popconfirm
							title="Are you sure delete this reservation?"
							onConfirm={() => {
								const { deleteFacilityReservation } = this.props
								deleteFacilityReservation({ facility_reservation_uid: reservation.uid })
									.then((response) => {
										message.success('Reservation successfully deleted.')

										//create audit trail
										const auditParams = {
											module_name: 'Reservations',
											action: 'Delete',
											message: `Deleted reservation ${reservation.facility_name} of ${reservation.name}`
										}
										AuthStore.saveAuditTrail(auditParams)
										onCancel()
									}).catch(err => {
										console.log('error deleting reservation', err)
										message.error(err.message.replace('GraphQL error:', ''))
									})
							}}
							// onCancel={cancel}
							okText="Yes"
							cancelText="No"
						>
							<button type="button" className="btn btn-danger btn-rounded waves-effect waves-light">Delete</button>
						</Popconfirm>
					}
				</Row>
			</Modal>
		)
	}
}

const DELETE_RESERVATION = gql`
    mutation deleteFacilityReservation($input: JSON) {
		deleteFacilityReservation(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(DELETE_RESERVATION, {
		props({ mutate }) {
			return {
				deleteFacilityReservation(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['reservationByDate']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)